export const environment = {
  production: true,
  API_ENDPOINT: 'https://www.api.easydesignintool.signify.com/api/v1/admin',
  API_ENDPOINT_V2: 'https://www.api.easydesignintool.signify.com/api/v2/admin',
  BASE_URL: 'https://www.api.easydesignintool.signify.com',
  BASE_URL_EDIT_2: 'https://www.easydesignintool.signify.com',
  SIGNIFY_TRIGGER: '.easydesignintool.signify.com',
  API_ENDPOINT_SIGNIFY: 'https://www.api.easydesignintool.signify.com/api/v1/admin',
  BASE_URL_SIGNIFY: 'https://www.api.easydesignintool.signify.com',
  ENV: 'prod',
  ENV_MESSAGE: '',
  SPC_ENDPOINT: 'http://sig-spc-p.westeurope.cloudapp.azure.com/api/v1',
  OIDC_ISSUER: 'https://ayffos6hz.accounts.ondemand.com',
  OIDC_CLIENT_ID: 'dd1001e3-1c41-4349-bd58-e05c44b68852',
  SENTRY_DSN: 'https://efd23d3e44c019a908a5f10a857d4188@sentry2021.trimm.net/58',
  SENTRY_ENVIRONMENT: 'production',
  SENTRY_RELEASE: 'master'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts